import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const Label = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #14171f;
  text-decoration: underline;
  text-underline-offset: 2px;
`
